import React from 'react';
import './style.css';
import titleImage from '../../assets/Jenni & Patrick -2.jpg';

export class Title extends React.Component {
    render() {
        return (
            <div id="title-screen">
                <div className="title-image-container">
                    <img alt="Verlobungsbild" src={titleImage} className="title-image" />
                    <div className="title-content-container">
                        <div className="title-content">
                            Jenni <br /> & <br /> Patrick
                        </div>
                    </div>
                </div>
            </div>
        );
        // return <div className="title-header">Wir heiraten!</div>;
    }
}
